import axios from "axios";
import { SAVE_JOB_REQUEST_URL } from "../utils";

export const saveJobRequest = async (jobRequestId: string) => {
  return await axios.post(SAVE_JOB_REQUEST_URL, {
    jobRequestId,
  });
};
